import { SurveyQuestion, SurveySegmentation } from '..';
import { LanguageCode } from '..';

export const SurveyTypes = ['WPA', 'Pulse'] as const;
export type SurveyType = typeof SurveyTypes[number];

// start and end are read from the referenced Activity, not stored independently on the survey
export type Survey =
SurveyData &
{
    answerCount: number;
    finishedAnswerCount: number,
    start: Date,
    end: Date
};

export type SurveyData =
{
    id:string,
    activityId:string,
    type: SurveyType,
    introduction:SurveyIntroduction,
    languageCode: LanguageCode,
    translationLanguages:LanguageCode[],
    segmentations: SurveySegmentation[],
    themes: SurveyTheme[]
};

export type LocalizedSurveyText = 
{
    languageCode:LanguageCode,
    text:string
}

export type SurveyIntroduction = 
{
    text:string,
    translations:LocalizedSurveyText[]
};

export type SurveyTheme =
{
    name:string,
    translations:LocalizedSurveyText[],
    questions: SurveyQuestion[]
}

export type SurveyStatus = 
    {
        access: 'waiting' | 'open' | 'closed',
        canEdit: boolean,
        hasQuestions: boolean,
        canSubmitAnswer: boolean,
        warning: '' | 'empty theme(s)'
    }

